import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-registration-alt-details-coupon-dialog',
    template: require('./registrationEasyDialogNoProperty.html')
})
export class RegistrationEasyNoPropertyDialog  {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<RegistrationEasyNoPropertyDialog>) public dialogRef: MatDialogRef<RegistrationEasyNoPropertyDialog>) {
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }
}
